import Footer from '@web/sections/Footer'
import { Outlet, useLocation } from 'react-router-dom'
import BackToTop from '@web/components/BackToTop'
import { useEffect } from 'react'

function ScrollToTopOnNavigate() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

export default function MarketingLayout() {
  return (
    <div className="h-full antialiased bg-white scroll-smooth">
      <ScrollToTopOnNavigate />
      <main className="h-full">
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
    </div>
  )
}
